module.exports = __webpack_public_path__ + "static/media/nef-bahcelievler.6cd5ff63.jpg";